import { render, staticRenderFns } from "./Allots.vue?vue&type=template&id=e2ec4372&scoped=true"
import script from "./Allots.vue?vue&type=script&lang=js"
export * from "./Allots.vue?vue&type=script&lang=js"
import style0 from "./Allots.vue?vue&type=style&index=0&id=e2ec4372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ec4372",
  null
  
)

export default component.exports